module.exports = __webpack_public_path__ + "static/media/project1.57217818.png";